import "bootstrap/dist/css/bootstrap.css";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import Layout from "./Layout";
import Authorization from "./pages/authorization";
import Crafting from "./pages/crafting";
import INeedALammie from "./pages/i-need-a-lammie";
import LammieGuidance from "./pages/lammie-guidance";
import ManageLammiePrinting from "./pages/manage-lammie-printing";
import ManageWisePrinting from "./pages/manage-wise-printing";
import PrintingLammies from "./pages/printing-lammies";
import PrintingWises from "./pages/printing-wises";
import WiseCards from "./pages/wise-cards";

export default function App() {
    return (
        <Routes>
            <Route path="/" element={<Layout />}>
                <Route index element={<Authorization />} />
                <Route path="/crafting-page" element={<Crafting />} />
                <Route path="/i-need-a-lammie" element={<INeedALammie />} />
                <Route
                    path="/manage-lammie-printing"
                    element={<ManageLammiePrinting />}
                />
                <Route path="/view-print-list" element={<PrintingLammies />} />
                <Route path="/path-wise-cards" element={<WiseCards />} />
                <Route path="/manage-wise-printing" element={<ManageWisePrinting />} />
                <Route path="/view-wise-print-list" element={<PrintingWises />} />
                <Route path="/guidance" element={<LammieGuidance />} />
            </Route>
        </Routes>
    );
}
